class PersonMembership {
    id = null;
    person_id = null;
    membership_id = null;
    start_date = '';
    name = '';
    duration = null;
    price = 0;
    invoice_id = null;

    constructor(data = {}, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default PersonMembership;
